import { render, staticRenderFns } from "./chatroomList.vue?vue&type=template&id=a4c11750&"
import script from "./chatroomList.vue?vue&type=script&lang=js&"
export * from "./chatroomList.vue?vue&type=script&lang=js&"
import style0 from "./chatroomList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports